import { Box, Typography } from '@mui/material'

import SearchQuestionIcon from '@/src/assets/svgs/SearchQuestionIcon'

export interface WalletEmptyStateProps {
    title: string
    message: string
}

const WalletEmptyState = ({ title, message }: WalletEmptyStateProps) => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                py: { xs: 6, md: 8 },
                px: 2
            }}
        >
            {/* Magnifying glass with question mark icon */}
            <Box
                sx={{
                    mb: 3,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                <SearchQuestionIcon
                    sx={{
                        fontSize: { xs: 64, md: 84 },
                        color: 'text.disabled',
                        opacity: 0.6
                    }}
                />
            </Box>

            {/* Title */}
            <Typography
                variant="h6"
                sx={{
                    fontWeight: 600,
                    color: 'text.primary',
                    mb: 1.5,
                    textAlign: 'center',
                    fontSize: { xs: '1rem', md: '1.25rem' }
                }}
            >
                {title}
            </Typography>

            {/* Message */}
            <Typography
                variant="body2"
                sx={{
                    color: 'text.secondary',
                    textAlign: 'center',
                    maxWidth: { xs: 280, md: 400 },
                    fontSize: { xs: '0.875rem', md: '0.9375rem' },
                    lineHeight: 1.5
                }}
            >
                {message}
            </Typography>
        </Box>
    )
}

export { WalletEmptyState }
